module.exports = __webpack_public_path__ + "static/media/cpl.5d103f5b.png";